











import { Component, Vue, Prop } from "vue-property-decorator";
import CouponDto from "../coupon/model/couponDto";
@Component
export default class CouponTable extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  data!: Array<CouponDto>;

  @Prop({
    type: Boolean,
    default: false
  })
  showPrice!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  showQuantity!: boolean;

  get columns() {
    let temp: any[] = [
      {
        title: "优惠券名称",
        key: "name"
      },
      {
        title: "优惠券类型",
        key: "couponTypeDisplayName"
      },
      {
        title: "优惠券有效期",
        key: "validDate"
      },
      {
        title: "操作",
        key: "action",
        slot: "action"
      }
    ];
    if (this.showPrice) {
      temp.splice(3, 0, {
        title: "售价",
        key: "price",
        render: (h, params) => {
          return h("InputNumber", {
            props: {
              value: this.data[params.index].price,
              min: 1
            },
            on: {
              "on-change": (event: number) => {
                this.data[params.index].price = event;
              }
            }
          });
        }
      });
    }
    if (this.showQuantity){
      temp.splice(3, 0, {
        title: "数量",
        key: "quantity",
        render: (h, params) => {
          return h("InputNumber", {
            props: {
              value: this.data[params.index].quantity,
              min: 1
            },
            on: {
              "on-change": (event: number) => {
                this.data[params.index].quantity = event;
              }
            }
          });
        }
      });
    }
    return temp;
  }
  remove(index: number) {
    this.data.splice(index, 1);
  }
}
